import React from 'react'
import {
  MessageRenderer,
  type MessageData,
  type MessageSender,
  type SystemMessageMetadata,
} from './base/MessageRenderer'

// Re-export types for convenience
export type ChatMessageData = MessageData
export type { MessageSender, SystemMessageMetadata }

interface ChatMessageProps {
  message: ChatMessageData
  userName?: string
  onCopy?: (content: string) => void
  onEdit?: () => void
  onRegenerate?: () => void
}

/**
 * Full-featured chat message component
 *
 * This is a thin wrapper around MessageRenderer with variant='full'
 * Provides the complete message display with all actions and features
 *
 * Reduced from ~250 lines to ~20 lines by using MessageRenderer base component
 */
export const ChatMessage: React.FC<ChatMessageProps> = props => {
  return <MessageRenderer {...props} variant="full" />
}
